module.exports = __webpack_public_path__ + "img/4.184a6d57.jpg";